import { statusDropdownOptions } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { MovementPatternConstant, movementPatternDtlRequiredFieldList } from "presentation/constant/MovementPattern/MovementPatternConstant";
import { useMovementPatternVM } from "presentation/hook/MovementPattern/useMovementPatternVM";
import { useMovementPatternTracked } from "presentation/store/MovementPattern/MovementPatternProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo } from "react";
import { FieldType, HPHCheckbox, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const MovementPatternDtlEditPanel = () => {
    const MOVEMENT_PATTERN_CONSTANT = MovementPatternConstant.Table;
    const [movementPatternState] = useMovementPatternTracked();
    const movementPatternVM = useMovementPatternVM();
    const { isShowDtlAddPanel, isShowDtlEditPanel, currentDtlEditRow, masterState } = movementPatternState;
    const { isSaveClicked, allFormState } = masterState;

    const handleSave = useCallback(async () => {
        // if (!currentDtlEditRow.cntrStatus) {
        //     messageBarVM.showError("Container Status is mandatory.");
        //     return;
        // }
        // if (!currentDtlEditRow.movementCode) {
        //     messageBarVM.showError("Movement Indicator is mandatory.");
        //     return;
        // }
        // if (!currentDtlEditRow.fromOtChargeInd) {
        //     messageBarVM.showError("OT Charge (From) is mandatory.");
        //     return;
        // }
        // if (!currentDtlEditRow.toOtChargeInd) {
        //     messageBarVM.showError("OT Charge (To) is mandatory.");
        //     return;
        // }
        movementPatternVM.onSaveClicked();
        movementPatternVM.onDtlTempSave(currentDtlEditRow);
    }, [movementPatternVM, currentDtlEditRow]);

    const handClose = useCallback(() => {
        movementPatternVM.onCloseDtlEidtPanel();
    }, [movementPatternVM]);

    const memoCntrStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={''}
                fieldValue={currentDtlEditRow?.cntrStatus}
                fieldLabel={MOVEMENT_PATTERN_CONSTANT.CON_STATUS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrStatus'}
                maxLength={60}
                options={statusDropdownOptions}
                requiredFieldList={movementPatternDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    movementPatternVM.onDtlFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentDtlEditRow?.cntrStatus, MOVEMENT_PATTERN_CONSTANT.CON_STATUS, isSaveClicked, movementPatternVM])

    const memoMovementCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={''}
                fieldValue={currentDtlEditRow?.movementCode}
                fieldLabel={MOVEMENT_PATTERN_CONSTANT.MOVEMENT_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'movementCode'}
                maxLength={60}
                options={movementPatternState.dynamicOptions.moveIndDropdownOptions}
                requiredFieldList={movementPatternDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    movementPatternVM.onDtlFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentDtlEditRow?.movementCode, MOVEMENT_PATTERN_CONSTANT.MOVEMENT_IND, isSaveClicked, movementPatternState.dynamicOptions.moveIndDropdownOptions, movementPatternVM])

    const memoFromOtChargeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "270px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={movementPatternDtlRequiredFieldList}
                fieldLabel={MOVEMENT_PATTERN_CONSTANT.OT_FROM}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentDtlEditRow?.fromOtChargeInd === 'Y'}
                disabled={false}
                onChange={(e) => movementPatternVM.onDtlCheckboxChange(e.checked, "fromOtChargeInd")}
            />
        </div>
        , [MOVEMENT_PATTERN_CONSTANT.OT_FROM, currentDtlEditRow?.fromOtChargeInd, movementPatternVM])


    const memoToOtChargeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "270px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={movementPatternDtlRequiredFieldList}
                fieldLabel={MOVEMENT_PATTERN_CONSTANT.OT_TO}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentDtlEditRow?.toOtChargeInd === 'Y'}
                disabled={false}
                onChange={(e) => movementPatternVM.onDtlCheckboxChange(e.checked, "toOtChargeInd")}
            />
        </div>
        , [MOVEMENT_PATTERN_CONSTANT.OT_TO, currentDtlEditRow?.toOtChargeInd, movementPatternVM])


    return <>
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
                        <Sidebarheader style={{ width: '100%' }}>
                            <SidebarTitle>
                                {isShowDtlAddPanel && "New movement Pattern Company"}
                                {isShowDtlEditPanel && "Edit movement Pattern Company"}
                            </SidebarTitle>
                            <SidebarActionCross>
                                <>
                                    <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />
                                    <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                                </>
                            </SidebarActionCross>

                        </Sidebarheader>

                    </StyledSidebar>
                </div>
            </div>
            <div className={'add-edit-form'} style={{ height: '78vh', maxHeight: '78vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        <CriteriaItemContainer>
                            {memoCntrStatus}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoMovementCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoFromOtChargeInd}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoToOtChargeInd}
                        </CriteriaItemContainer>


                    </div>
                </div>
            </div>

        </div>
    </>
}

export default memo(MovementPatternDtlEditPanel);
